<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">

  <!-- HOME -->
  <div *ngIf="!showHistory && !showAutotest" class="row generalDiv">

    <div class="row titleSection">
      <div class="titleText">
        <h3 class="textXXM centerVert">Autotest</h3>
      </div>
    </div>

    <div *ngFor="let proyecto of user.getProyectos(); index as i" class="backLocationRow">
      <div class="row centerVert locationRow" style="color: white">

        <!-- INFO PROYECT COLUMN -->
        <div class="col-5 text-center" style="height: 100%; padding: 3px; border-right: 2px solid white">
          <div class="row insideRowPlace">
            <div class="row locationName">

              <div class="col-3 marginAuto">
                <span class="material-icons-outlined marginAuto textXXM">place</span>
              </div>

              <div class="col-9">
                <h1 class="centerVert padding-zero text-center textM">{{proyecto.nombre}}</h1>
              </div>

            </div>
          </div>
        </div>

        <!-- LAST TEST COLUMN -->
        <div class="col-2 text-center" (click)="selectAutotest(getLastByIdProyecto(proyecto.idProyecto))" style="height: 100%; padding: 3px; border-right: 2px solid white"
             [ngClass]="{'cursorPointer': getLastByIdProyecto(proyecto.idProyecto) != undefined}">
          <div class="row" style="height: 20%">
            <h3 class="textS+ marginAuto" style="text-decoration: underline">{{ this.localiser.get("autotest.lastTest") }}</h3>
          </div>
          <div class="row" style="height: 20%">
            <h3 *ngIf="!getLastByIdProyecto(proyecto.idProyecto) && !isRunningAutotest(proyecto.idProyecto)" class="textS+ marginAuto">{{ this.localiser.get("autotest.never") }}</h3>
            <h3 *ngIf="getLastByIdProyecto(proyecto.idProyecto) && getLastByIdProyecto(proyecto.idProyecto).status != 'Running' && !isRunningAutotest(proyecto.idProyecto)" class="textS+ marginAuto">{{getDate(getLastByIdProyecto(proyecto.idProyecto).startTime)}}</h3>
            <h3 *ngIf="getLastByIdProyecto(proyecto.idProyecto) && (getLastByIdProyecto(proyecto.idProyecto).status == 'Running' || isRunningAutotest(proyecto.idProyecto))" class="textS+ marginAuto">{{ this.localiser.get("autotest.runningNow") }}</h3>
          </div>
          <div class="row" style="height: 60%">
            <h3 *ngIf="!getLastByIdProyecto(proyecto.idProyecto)" class="textL marginAuto">?</h3>
            <span *ngIf="getLastByIdProyecto(proyecto.idProyecto) && getLastByIdProyecto(proyecto.idProyecto).status == '0' && !isRunningAutotest(proyecto.idProyecto)" class="material-icons-outlined textL marginAuto">check</span>
            <span *ngIf="getLastByIdProyecto(proyecto.idProyecto) && getLastByIdProyecto(proyecto.idProyecto).status == '1' && !isRunningAutotest(proyecto.idProyecto)" class="material-icons-outlined textL marginAuto">close</span>
            <span *ngIf="getLastByIdProyecto(proyecto.idProyecto) && getLastByIdProyecto(proyecto.idProyecto).status == '2' && !isRunningAutotest(proyecto.idProyecto)" class="material-icons-outlined textL marginAuto">sensors_off</span>
            <mat-progress-spinner *ngIf="getLastByIdProyecto(proyecto.idProyecto) && (getLastByIdProyecto(proyecto.idProyecto).status == 'Running' || isRunningAutotest(proyecto.idProyecto))" class="spinner" mode="indeterminate" diameter="40"></mat-progress-spinner>
            <span *ngIf="getLastByIdProyecto(proyecto.idProyecto) && getLastByIdProyecto(proyecto.idProyecto).status == 'Running'"
                  class="material-icons-outlined textM marginAuto" style="cursor:pointer; color:#e05252;"
                  title="{{ this.localiser.get('autotest.cancelAutotest') }}"
                  (click)="cancelAutotest(getLastByIdProyecto(proyecto.idProyecto)); $event.stopPropagation()">cancel</span>
          </div>
        </div>

        <!-- HISTORY COLUMN -->
        <div class="col-2 text-center" (click)="seeHistory(proyecto)" style="height: 100%; padding: 3px; border-right: 2px solid white; cursor: pointer">
          <div class="row" style="height: 20%">
            <h3 class="textS+ marginAuto" style="text-decoration: underline">{{ this.localiser.get("autotest.history") }}</h3>
          </div>

          <div class="row" style="height: 80%">
            <span class="material-icons-outlined textXL marginAuto">history</span>
          </div>
        </div>

        <!-- START NEW TEST COLUMN -->
        <div class="col-3 text-center" style="height: 100%; padding: 3px 4px 3px 4px;">
          <div (click)="openWarning(proyecto)" style="cursor:pointer; width: 100%; height: 100%; background-color: #F2A356; color: #18264f; border-radius: 0px 17px 17px 0px">
            <div class="row" style="height: 30%">
              <h3 *ngIf="!getLastByIdProyecto(proyecto.idProyecto) || getLastByIdProyecto(proyecto.idProyecto).status != 'progress'"
                  class="textS+ marginAuto" style="text-decoration: underline">{{ this.localiser.get("autotest.startNewAutotest") }}</h3>
              <h3 *ngIf="getLastByIdProyecto(proyecto.idProyecto) && getLastByIdProyecto(proyecto.idProyecto).status == 'progress'"
                  class="textS+ marginAuto" style="text-decoration: underline">{{ this.localiser.get("autotest.seeActualAutotest") }}</h3>
            </div>

            <div class="row" style="height: 70%">
              <span id="buttonStartNewAutotest" *ngIf="!isRunningAutotest(proyecto.idProyecto)"
                    class="material-icons-outlined textXL marginAuto">play_circle</span>
              <span *ngIf="getLastByIdProyecto(proyecto.idProyecto) && getLastByIdProyecto(proyecto.idProyecto).status == 'progress'"
                    class="material-icons-outlined textXL marginAuto">checklist</span>
              <mat-progress-spinner *ngIf="getLastByIdProyecto(proyecto.idProyecto) && (getLastByIdProyecto(proyecto.idProyecto).status == 'Running' || isRunningAutotest(proyecto.idProyecto))" class="spinner spinner-start-auto-test" mode="indeterminate" diameter="40"></mat-progress-spinner>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>

  <!-- SHOW HISTORY -->
  <div *ngIf="showHistory && !showAutotest"  class="row generalDiv">

    <div class="row titleSection">
      <div class="titleText">
        <h3 class="textXXM centerVert">{{ this.localiser.get("autotest.autotestHistory") }} - {{selectedProyecto.nombre}}</h3>
      </div>
    </div>

    <div *ngIf="loadedHistory && autotestProyectoHistory.length > 0" class="scrollerDiv">

      <div *ngFor="let autotestProyecto of autotestProyectoHistory; index as i" class="backLocationRowHistory">
      <div class="row centerVert locationRowHistory" style="color: white">

        <!-- STATUS ICON -->
        <div class="col-1">
          <span *ngIf="autotestProyecto.status == '0'" class="material-icons-outlined textL centerVert">check</span>
          <span *ngIf="autotestProyecto.status == '1'" class="material-icons-outlined textL marginAuto centerVert">close</span>
          <span *ngIf="autotestProyecto.status == '2'" class="material-icons-outlined textL marginAuto centerVert">sensors_off</span>
          <span *ngIf="autotestProyecto.status == 'Cancelled'" class="material-icons-outlined textL marginAuto centerVert">cancel</span>
          <mat-progress-spinner *ngIf="autotestProyecto.status == 'Running'" class="spinner centerVert" mode="indeterminate" diameter="40"></mat-progress-spinner>
        </div>

        <!-- STATUS -->
        <div class="col-2">
          <div class="row" style="height: 40%; margin: auto">
            <h3 class="textS marginAuto">{{ this.localiser.get("autotest.status") }}:</h3>
          </div>
          <div class="row" style="height: 40%; margin: auto; text-align: center">
            <h3 *ngIf="autotestProyecto.status == '1'" class="textS marginAuto">{{ this.localiser.get("autotest.emergencies") }}</h3>
            <h3 *ngIf="autotestProyecto.status == '2'" class="textS marginAuto">{{ this.localiser.get("autotest.notCommunicating") }}</h3>
            <h3 *ngIf="autotestProyecto.status == '0'" class="textS+ marginAuto">{{ this.localiser.get("autotest.finished") }}</h3>
            <h3 *ngIf="autotestProyecto.status == 'Cancelled'" class="textS marginAuto">{{ this.localiser.get("autotest.cancelled") }}</h3>
          </div>
        </div>

        <!-- TIME -->
        <div class="col-2">
          <div class="row marginAuto" style="height: 60%">
            <h3 class="textS+ marginAuto">{{getDate(autotestProyecto.startTime)}}</h3>
          </div>
          <div class="row marginAuto" style="height: 30%">
            <h3 class="textS marginAuto">{{getHourAndMinutes(autotestProyecto.startTime)}}</h3>
          </div>
        </div>


        <!-- INFO LUMS -->
        <div class="col-5">
          <div class="row marginAuto" style="height: 50%">
            <h3 class="textS+ marginAuto">{{ this.localiser.get("autotest.luminaires") }}</h3>
          </div>
          <div class="row marginAuto" style="height: 50%">

            <div class="col-4">
              <div class="row">
                <div class="col-6" style="text-align: right">
                  <span class="material-icons-outlined textS+ centerVert">check</span>
                </div>
                <div class="col-6">
                  <h3 class="textS+ centerVert">{{countLumsByStatus(autotestProyecto, "0")}}</h3>
                </div>
              </div>
            </div>


            <div class="col-4">
              <div class="row">
                <div class="col-6" style="text-align: right">
                  <span class="material-icons-outlined textS+ centerVert">close</span>
                </div>
                <div class="col-6">
                  <h3 class="textS+ centerVert">{{countLumsByStatus(autotestProyecto, "1")}}</h3>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="row">
                <div class="col-6" style="text-align: right">
                  <span class="material-icons-outlined textS+ centerVert">sensors_off</span>
                </div>
                <div class="col-6">
                  <h3 class="textS+ centerVert">{{countLumsByStatus(autotestProyecto, "2")}}</h3>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- CANCEL (only when Running) -->
        <div *ngIf="autotestProyecto.status == 'Running'" class="col-2" (click)="cancelAutotest(autotestProyecto)" style="cursor:pointer; color: white; background-color: #e05252; border-radius: 0 17px 17px 0">
          <div class="row marginAuto" style="height: 50%">
            <h3 class="textS+ marginAuto">{{ this.localiser.get("autotest.cancelAutotest") }}</h3>
          </div>
          <div class="row marginAuto" style="height: 30%">
            <span class="material-icons-outlined textL centerVert marginAuto">cancel</span>
          </div>
        </div>
        <!-- SEE LUMS -->
        <div *ngIf="autotestProyecto.status != 'Running'" class="col-2" (click)="selectAutotest(autotestProyecto)" style="cursor:pointer; color: #18264f; background-color: #F2A356; border-radius: 0 17px 17px 0">
          <div class="row marginAuto" style="height: 50%">
            <h3 class="textS+ marginAuto">{{ this.localiser.get("autotest.seeLums") }}</h3>
          </div>
          <div class="row marginAuto" style="height: 30%">
            <span class="material-icons-outlined textL centerVert marginAuto">arrow_right_alt</span>
          </div>
        </div>

      </div>
    </div>

    </div>

    <div *ngIf="!loadedHistory || autotestProyectoHistory.length == 0" class="container marginAuto" style="height: 40vh; text-align: center">
      <mat-progress-spinner *ngIf="!loadedHistory" class="spinner centerVert marginAuto" mode="indeterminate" diameter="100"></mat-progress-spinner>
      <h3 *ngIf="loadedHistory && autotestProyectoHistory.length == 0" class="textM marginAuto centerVert"> {{ this.localiser.get("autotest.thereAreNoAutotestsYetInProject") }}</h3>
    </div>

    <div class="container" style="margin: 2vh auto">
      <button (click)="returnHome()" class="backButton">
        <span class="material-icons-outlined textL">
        undo
        </span>
      </button>
    </div>

  </div>

  <!-- SHOW AUTOTEST PROJECT -->
  <div *ngIf="!showHistory && showAutotest && selectedAutotestProyecto"  class="row generalDiv">


    <div class="row titleSection">
      <div class="titleTextLums">
        <h3 class="textXXM marginAuto">Autotest - {{selectedProyecto.nombre}}</h3>
        <h3 class="textS+ marginAuto">{{getDateAndHour(selectedAutotestProyecto.startTime)}}</h3>
        <div class="row" style="width: 100%; margin: 1vh auto">
          <div class="row marginAuto" style="height: 50%">

            <div class="col-4">
              <div class="row">
                <div class="col-6" style="text-align: right">
                  <span class="material-icons-outlined textS+ centerVert">check</span>
                </div>
                <div class="col-6">
                  <h3 class="textS+ centerVert">{{countLumsByStatus(selectedAutotestProyecto, "0")}}</h3>
                </div>
              </div>
            </div>


            <div class="col-4">
              <div class="row">
                <div class="col-6" style="text-align: right">
                  <span class="material-icons-outlined textS+ centerVert">close</span>
                </div>
                <div class="col-6">
                  <h3 class="textS+ centerVert">{{countLumsByStatus(selectedAutotestProyecto, "1")}}</h3>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="row">
                <div class="col-6" style="text-align: right">
                  <span class="material-icons-outlined textS+ centerVert">sensors_off</span>
                </div>
                <div class="col-6">
                  <h3 class="textS+ centerVert">{{countLumsByStatus(selectedAutotestProyecto, "2")}}</h3>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="scrollerDivLums">

      <div *ngIf="selectedAutotestProyecto.status == 'Running'" class="container marginAuto" style="height: 8vh; text-align: center">
        <mat-progress-spinner class="spinner centerVert marginAuto" mode="indeterminate" diameter="40"></mat-progress-spinner>
      </div>

      <div *ngFor="let autotest of selectedAutotestProyecto.luminariasFinished; index as i" class="backLocationRowHistory">
        <div class="row centerVert locationRowHistory" style="color: white">

          <!-- STATUS ICON -->
          <div class="col-1">
            <span *ngIf="autotest.status == '0'" class="material-icons-outlined textL centerVert">check</span>
            <span *ngIf="autotest.status == '1'" class="material-icons-outlined textL marginAuto centerVert">close</span>
            <span *ngIf="autotest.status == '2'" class="material-icons-outlined textL marginAuto centerVert">sensors_off</span>
          </div>

          <!-- LUMINAIRE ID -->
          <div class="col-3" style="margin: auto 0;">
            <div class="row" style="height: 30%; margin: auto">
              <h3 class="textS marginAuto">{{autotest.idDispositivo}}</h3>
            </div>
            <div class="row" style="height: 30%; margin: auto">
              <h3 *ngIf="autotest.stamp_T > 1" class="textS marginAuto">{{getDateAndHour(autotest.stamp_T * 1000)}}</h3>
              <h3 *ngIf="autotest.stamp_T <= 1" class="textS marginAuto">{{ this.localiser.get("autotest.noData") }}</h3>
            </div>
          </div>

          <!-- RSSI -->
          <div class="col-2">
            <div class="row" style="height: 50%; margin: auto">
              <h3 class="textS marginAuto">{{ this.localiser.get("autotest.RSSI") }}:</h3>
            </div>
            <div class="row" style="height: 30%; margin: auto">
              <h3 *ngIf="autotest.rssi < 0" class="textS+ marginAuto">{{autotest.rssi}}</h3>
              <h3 *ngIf="autotest.rssi >= 0" class="textS+ marginAuto">{{ this.localiser.get("autotest.noData") }}</h3>
            </div>
          </div>

          <!-- PCG - LIGHT LEVEL -->
          <div class="col-2">
            <div class="row" style="height: 50%; margin: auto">
              <h3 class="textS marginAuto">{{ this.localiser.get("autotest.lightLevel") }}:</h3>
            </div>
            <div class="row" style="height: 30%; margin: auto">
              <h3 *ngIf="autotest.pcg != -1" class="textS+ marginAuto">{{autotest.pcg}}%</h3>
              <h3 *ngIf="autotest.pcg == -1" class="textS+ marginAuto">{{ this.localiser.get("autotest.noData") }}</h3>
            </div>
          </div>

          <!-- W - POWER CONSUMPTION -->
          <div class="col-2">
            <div class="row" style="height: 50%; margin: auto">
              <h3 class="textS marginAuto">{{ this.localiser.get("autotest.consumption") }}:</h3>
            </div>
            <div class="row" style="height: 30%; margin: auto">
              <h3 *ngIf="autotest.w != -1" class="textS+ marginAuto">{{autotest.w}}W</h3>
              <h3 *ngIf="autotest.w == -1" class="textS+ marginAuto">{{ this.localiser.get("autotest.noData") }}</h3>
            </div>
          </div>

          <!-- EMG -->
          <div class="col-2">
            <div class="row" style="height: 50%; margin: auto">
              <h3 class="textS marginAuto">{{ this.localiser.get("autotest.emergencies") }}:</h3>
            </div>
            <div class="row" style="height: 30%; margin: auto">
              <div *ngIf="getHasEmergencyModule(autotest)" id="emergencyLed" class="emergency marginAuto" [ngClass]="{'green': getLastEmergency(autotest) == 0,
                      'red': getLastEmergency(autotest) == 1, 'flashRed': getLastEmergency(autotest) == 2}">
              </div>
              <h3 *ngIf="!getHasEmergencyModule(autotest)" class="textS marginAuto">{{ this.localiser.get("autotest.noEmergency") }}</h3>
            </div>
          </div>


        </div>
        <div *ngIf="user.getPermiso() != 'Ateneo'" (click)="goToInfoLuminaria(autotest)" style="width: 5%; cursor: pointer">
            <span class="material-icons-outlined buttonMapInfo textXM centerVert">
                info
            </span>
        </div>
      </div>

    </div>


    <div class="container" style="margin: 2vh auto">
      <button (click)="returnSelectProyecto()" class="backButton">
        <span class="material-icons-outlined textL">
        undo
        </span>
      </button>
    </div>

  </div>

</div>
